import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import { getModuleFromPath } from 'helpers/pathParser';
import { useFetchWellsWithWellbores } from 'hooks/useFetchWellsWithWellbores';
import { useGetWellOptions } from 'hooks/useGetWellOptions';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';
import { useSelectUser } from 'redux/User/selectors';
import { useSelectCurrentWell, useSelectCurrentWellbore } from 'redux/Wells/selectors';
import { WellFullDetailsDTO } from 'types/well';

import styles from './SidebarContentDrillX.module.scss';
import { useSidebarRoutes } from '../../utils/RouteLinks';
import SidebarRouteLink from '../SidebarRouteLink';
import WellSelect from '../WellSelect';

const SidebarContentDrillX: React.FunctionComponent = () => {
  const intl = useIntl();
  const match = useRouteMatch();
  const currentModule = getModuleFromPath(match.path);
  const { wells, wellsAndWellboresLoading } = useFetchWellsWithWellbores();
  const wellOptions = useGetWellOptions();
  const currentWell: WellFullDetailsDTO | undefined = useSelectCurrentWell();
  const currentWellBore = useSelectCurrentWellbore();
  const user = useSelectUser();
  const sidebarRoutes = useSidebarRoutes({
    tuwi: currentWell?.tuwi,
    tightWellAccessible: user?.tightWellAccessible || false,
    currentWell,
  });

  return wells && wells.length !== 0 ? (
    <div className={styles.linksContainer}>
      <Grid container item direction="column">
        <Typography variant="overline" className={styles.myWellsTitle}>
          {intl.formatMessage({ id: 'sidebar.myWells' })}
        </Typography>
        <WellSelect
          currentModule={currentModule}
          wellboresLoading={wellsAndWellboresLoading}
          wellOptions={wellOptions}
          wells={wells}
          path={match.path}
          tightWellAccessible={user?.tightWellAccessible}
        />
      </Grid>
      <List component="nav" className={styles.routesContainer}>
        {sidebarRoutes
          .filter(routeGroup => routeGroup.isHidden !== true)
          .map(routeGroup => (
            <SidebarRouteLink
              key={routeGroup.name}
              name={routeGroup.name}
              well={currentWell}
              wellbore={currentWellBore}
              routes={routeGroup.routes}
            />
          ))}
      </List>
    </div>
  ) : (
    <CircularProgress size={80} className={styles.circularProgress} />
  );
};

export default SidebarContentDrillX;
